
// import { useState, useEffect } from 'react';
// import { useLanguage } from '../context/LanguageContext';
// import axios from 'axios';
// import './Booking.css';

// const API_BASE = 'http://localhost:8000/api';

// function YadnyaBooking() {

// const { t } = useLanguage();


// useEffect(() => {
//   const script = document.createElement("script");
//   script.src = "https://checkout.razorpay.com/v1/checkout.js";
//   script.async = true;
//   document.body.appendChild(script);
// }, []);






//   // Step Management
//   const [step, setStep] = useState(1); // 1: OTP, 2: Terms, 3: Booking Form, 4: Payment

//   // OTP Step
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState('');
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);
//   const [otpError, setOtpError] = useState('');

//   // Terms Step
//   const [agreeTerms, setAgreeTerms] = useState(false);

//   // Booking Form Data
//   const [yadnyas, setYadnyas] = useState([]);
//   const [selectedYadnya, setSelectedYadnya] = useState('');
//   const [dates, setDates] = useState([]);
//   const [selectedDate, setSelectedDate] = useState('');
//   const [personsCount, setPersonsCount] = useState(1);
//   const [personDetails, setPersonDetails] = useState([{ name: '', email: '', age: '' }]);
//   const [pricePerPerson, setPricePerPerson] = useState(0);
//   const [error, setError] = useState('');

//   // Payment
//   const [orderId, setOrderId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const totalAmount = pricePerPerson * personsCount;

//   // Fetch all Yadnya (after login)
//   useEffect(() => {
//     if (step >= 3) {
//       const fetchYadnyas = async () => {
//         try {
//           const res = await axios.get(`${API_BASE}/yadnya`, {
//             headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//           });
//           setYadnyas(res.data || []);
//         } catch (err) {
//           console.error("Error fetching yadnyas:", err);
//         }
//       };
//       fetchYadnyas();
//     }
//   }, [step]);

//   // Fetch Dates when Yadnya is selected
//   useEffect(() => {
//     if (!selectedYadnya || step < 3) return;

//     const fetchDates = async () => {
//       try {
//         const res = await axios.get(`${API_BASE}/yadnya/${selectedYadnya}/dates`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//         });
//         setDates(res.data || []);

//         const selected = yadnyas.find(y => y.id === parseInt(selectedYadnya));
//         if (selected) {
//           setPricePerPerson(parseFloat(selected.price_per_person) || 0);
//         }
//       } catch (err) {
//         console.error("Error fetching dates:", err);
//       }
//     };

//     fetchDates();
//   }, [selectedYadnya, yadnyas, step]);

//   // Generate person detail fields
//   useEffect(() => {
//     const newDetails = Array.from({ length: personsCount }, () => ({
//       name: '',
//       email: '',
//       age: ''
//     }));
//     setPersonDetails(newDetails);
//   }, [personsCount]);

//   // ========== OTP Functions ==========
//   const sendOtp = async () => {
//     if (!email) {
//       setOtpError('Please enter your email address');
//       return;
//     }

//     setOtpLoading(true);
//     setOtpError('');

//     try {
//       await axios.post(`${API_BASE}/send-otp`, { email });
//       setOtpSent(true);
//       alert('OTP has been sent to your email. Please check your inbox.');
//     } catch (err) {
//       setOtpError(err.response?.data?.error || 'Failed to send OTP');
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   const verifyOtp = async () => {
//     if (!otp || otp.length !== 6) {
//       setOtpError('Please enter valid 6-digit OTP');
//       return;
//     }

//     setOtpLoading(true);
//     setOtpError('');

//     try {
//       const res = await axios.post(`${API_BASE}/verify-otp`, { email, otp });
      
//       localStorage.setItem('token', res.data.token);
//       setOtpError('');
//       setStep(2); // Move to Terms & Conditions
//     } catch (err) {
//       setOtpError(err.response?.data?.error || 'Invalid or expired OTP');
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   // ========== Booking Form Functions ==========
//   const updatePersonDetail = (index, field, value) => {
//     const updated = [...personDetails];
//     updated[index][field] = value;
//     setPersonDetails(updated);
//   };

//   const validateBookingForm = () => {
//     if (!selectedYadnya || !selectedDate) {
//       setError('Please select Yadnya and Date');
//       return false;
//     }
//     if (personDetails.some(p => !p.name || !p.email || !p.age)) {
//       setError('Please fill complete details for all persons');
//       return false;
//     }
//     return true;
//   };

//   const handleProceedToPayment = async () => {
//   if (!validateBookingForm()) return;

//   setLoading(true);
//   setError('');

//   try {
//     const res = await axios.post(
//       `${API_BASE}/booking/create-order`,
//       {
//         total_amount: totalAmount,
//         yadnya_id: parseInt(selectedYadnya),
//         yadnya_date: selectedDate,
//         total_person: personsCount,
//         persons: personDetails
//       },
//       {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//       }
//     );

//     console.log("ORDER RESPONSE", res.data);

//     if (!window.Razorpay) {
//       alert("Razorpay SDK failed to load");
//       return;
//     }

//     const options = {
//       key: res.data.key,
//       amount: totalAmount * 100,
//       currency: "INR",
//       name: "Yadnya Booking",
//       description: "Payment for Yadnya",
//       order_id: res.data.order_id,

// //       handler: async function (response) {
// //   try {
// //     await axios.post(
// //       `${API_BASE}/booking/verify-payment`,
// //       {
// //         user_email: email,   // ⭐ IMPORTANT
// //         razorpay_payment_id: response.razorpay_payment_id,
// //         razorpay_order_id: response.razorpay_order_id,
// //         razorpay_signature: response.razorpay_signature,
// //         yadnya_id: parseInt(selectedYadnya),
// //         yadnya_date: selectedDate,
// //         total_person: personsCount,
// //         total_amount: totalAmount,
// //         persons: personDetails
// //       },
// //       {
// //         headers: {
// //           Authorization: `Bearer ${localStorage.getItem('token')}`
// //         }
// //       }
// //     );

// //     alert("Booking confirmed successfully!");
// //     window.location.reload();

// //   } catch (err) {
// //     console.error(err);
// //     alert("Payment verification failed");
// //   }
// // },




// handler: async function (response) {

//   const res = await axios.post(
//     `${API_BASE}/booking/verify-payment`,
//     {
//       user_email: email,
//       razorpay_payment_id: response.razorpay_payment_id,
//       yadnya_id: parseInt(selectedYadnya),
//       yadnya_date: selectedDate,
//       total_person: personsCount,
//       total_amount: totalAmount,
//       persons: personDetails
//     },
//     {
//       responseType: 'blob' // ⭐ important
//     }
//   );

//   const url = window.URL.createObjectURL(new Blob([res.data]));
//   const link = document.createElement('a');
//   link.href = url;
//   link.setAttribute('download', 'booking.pdf');
//   document.body.appendChild(link);
//   link.click();
// },





//       prefill: {
//         email: email
//       },

//       theme: {
//         color: "#3399cc"
//       }
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();

//   } catch (err) {
//     console.error(err);
//     setError("Failed to initiate payment");
//   } finally {
//     setLoading(false);
//   }
// };

//   const verifyPayment = async (paymentId, orderIdFromRazorpay) => {
//     try {
//       await axios.post(
//         `${API_BASE}/booking/verify-payment`,
//         {
//           razorpay_payment_id: paymentId,
//           razorpay_order_id: orderIdFromRazorpay,
//           yadnya_id: parseInt(selectedYadnya),
//           yadnya_date: selectedDate,
//           total_person: personsCount,
//           total_amount: totalAmount,
//           persons: personDetails
//         },
//         {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//         }
//       );

//       alert('Booking confirmed successfully!');
//       // Optionally redirect to booking confirmation page
//       window.location.reload(); // or navigate to success page
//     } catch (err) {
//       alert('Payment verification failed. Please contact support.');
//       console.error(err);
//     }
//   };

//   // ========== Render Steps ==========
//   return (
//     <div className="booking-container">
//       <div className="booking-card">

//         {/* Step 1: Email OTP Login */}
//         {step === 1 && (
//           <div className="booking-step">
//             <div className="booking-header">
//               <h2>{t('yadnya.loginToContinue')}</h2>
//             </div>
//             <div className="booking-body">
//               <div className="form-group">
//                 <label>Email Address</label>
//                 <input
//                   type="email"
//                   placeholder="Enter your email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   disabled={otpSent}
//                 />
//               </div>

//               {otpSent && (
//                 <div className="form-group">
//                   <label>Enter OTP</label>
//                   <input
//                     type="text"
//                     maxLength={6}
//                     placeholder="6-digit OTP"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                   />
//                 </div>
//               )}

//               {otpError && <div className="error-alert">{otpError}</div>}

//               <button 
//                 className="proceed-btn" 
//                 onClick={otpSent ? verifyOtp : sendOtp}
//                 disabled={otpLoading}
//               >
//                 {otpLoading 
//                   ? 'Processing...' 
//                   : otpSent 
//                     ? 'Verify OTP' 
//                     : 'Send OTP'
//                 }
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Step 2: Terms & Conditions */}
//         {step === 2 && (
//           <div className="booking-step">
//             <div className="booking-header">
//               <h2>Terms & Conditions</h2>
//             </div>
//             <div className="booking-body">
//               <div className="terms-content">
//                 <p>Please read and accept the following terms before proceeding with the booking:</p>
//                 <ul>
//                   <li>All bookings are non-refundable except in case of cancellation by the organizer.</li>
//                   <li>Valid government ID may be required at the venue.</li>
//                   <li>Participants must follow all guidelines during the Yadnya.</li>
//                   <li>Any misbehavior may result in cancellation without refund.</li>
//                 </ul>
//               </div>

//               <div className="terms">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={agreeTerms}
//                     onChange={(e) => setAgreeTerms(e.target.checked)}
//                   />
//                   I have read and agree to the Terms & Conditions
//                 </label>
//               </div>

//               <button 
//                 className="proceed-btn" 
//                 onClick={() => setStep(3)}
//                 disabled={!agreeTerms}
//               >
//                 Continue to Booking
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Step 3: Booking Form */}
//         {step === 3 && (
//           <div className="booking-step">
//             <div className="booking-header">
//               <h2>Yadnya Booking</h2>
//             </div>
//             <div className="booking-body">
//               {error && <div className="error-alert">{error}</div>}

//               {/* Yadnya Selection */}
//               <div className="form-group">
//                 <label>Select Yadnya / Pooja</label>
//                 <select
//                   value={selectedYadnya}
//                   onChange={(e) => setSelectedYadnya(e.target.value)}
//                 >
//                   <option value="">-- Select Yadnya --</option>
//                   {yadnyas.map((y) => (
//                     <option key={y.id} value={y.id}>
//                       {y.title} - ₹{parseFloat(y.price_per_person).toFixed(0)}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Date Selection */}
//               <div className="form-group">
//                 <label>Select Date</label>
//                 <select
//                   value={selectedDate}
//                   onChange={(e) => setSelectedDate(e.target.value)}
//                   disabled={!selectedYadnya}
//                 >
//                   <option value="">-- Select Date --</option>
//                   {dates.map((d) => (
//                     <option key={d.id} value={d.event_date}>
//                       {d.event_date}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Number of Persons */}
//               <div className="form-group">
//                 <label>Number of Persons</label>
//                 <input
//                   type="number"
//                   min="1"
//                   value={personsCount}
//                   onChange={(e) => setPersonsCount(Math.max(1, parseInt(e.target.value) || 1))}
//                 />
//               </div>

//               {/* Price Summary */}
//               <div className="price-box">
//                 <h5>Price Details</h5>
//                 <p>Per Person: <strong>₹{pricePerPerson}</strong></p>
//                 <p>Total Amount: <strong>₹{totalAmount}</strong></p>
//               </div>

//               {/* Person Details */}
//               <h5>Enter Details of {personsCount} Person(s)</h5>
//               {personDetails.map((person, index) => (
//                 <div key={index} className="person-card">
//                   <h6>Person {index + 1}</h6>
//                   <div className="person-grid">
//                     <input
//                       type="text"
//                       placeholder="Full Name"
//                       value={person.name}
//                       onChange={(e) => updatePersonDetail(index, 'name', e.target.value)}
//                     />
//                     <input
//                       type="email"
//                       placeholder="Email Address"
//                       value={person.email}
//                       onChange={(e) => updatePersonDetail(index, 'email', e.target.value)}
//                     />
//                     <input
//                       type="number"
//                       placeholder="Age"
//                       value={person.age}
//                       onChange={(e) => updatePersonDetail(index, 'age', e.target.value)}
//                     />
//                   </div>
//                 </div>
//               ))}

//               <button 
//                 className="proceed-btn" 
//                 onClick={handleProceedToPayment}
//                 disabled={loading}
//               >
//                 {loading ? 'Processing Payment...' : 'Proceed to Payment'}
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default YadnyaBooking;













// import { useState, useEffect } from 'react';
// import { useLanguage } from '../context/LanguageContext';
// import axios from 'axios';
// import './Booking.css';

// const API_BASE = 'http://localhost:8000/api';

// function YadnyaBooking() {
//   const { t } = useLanguage();   // This gives you t('yadnya.loginToContinue') etc.

//   // Razorpay Script
//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     document.body.appendChild(script);
//   }, []);

//   // Step Management
//   const [step, setStep] = useState(1); // 1: OTP, 2: Terms, 3: Booking Form

//   // OTP Step
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState('');
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);
//   const [otpError, setOtpError] = useState('');

//   // Terms Step
//   const [agreeTerms, setAgreeTerms] = useState(false);

//   // Booking Form Data
//   const [yadnyas, setYadnyas] = useState([]);
//   const [selectedYadnya, setSelectedYadnya] = useState('');
//   const [dates, setDates] = useState([]);
//   const [selectedDate, setSelectedDate] = useState('');
//   const [personsCount, setPersonsCount] = useState(1);
//   const [personDetails, setPersonDetails] = useState([{ name: '', email: '', age: '' }]);
//   const [pricePerPerson, setPricePerPerson] = useState(0);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [loading, setLoading] = useState(false);

//   const totalAmount = pricePerPerson * personsCount;

//   // Fetch Yadnyas after OTP
//   useEffect(() => {
//     if (step >= 3) {
//       const fetchYadnyas = async () => {
//         try {
//           const res = await axios.get(`${API_BASE}/yadnya`, {
//             headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//           });
//           setYadnyas(res.data || []);
//         } catch (err) {
//           console.error("Error fetching yadnyas:", err);
//         }
//       };
//       fetchYadnyas();
//     }
//   }, [step]);

//   // Fetch Dates when Yadnya selected
//   useEffect(() => {
//     if (!selectedYadnya || step < 3) return;

//     const fetchDates = async () => {
//       try {
//         const res = await axios.get(`${API_BASE}/yadnya/${selectedYadnya}/dates`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//         });
//         setDates(res.data || []);

//         const selected = yadnyas.find(y => y.id === parseInt(selectedYadnya));
//         if (selected) {
//           setPricePerPerson(parseFloat(selected.price_per_person) || 0);
//         }
//       } catch (err) {
//         console.error("Error fetching dates:", err);
//       }
//     };

//     fetchDates();
//   }, [selectedYadnya, yadnyas, step]);

//   // Generate person detail fields
//   useEffect(() => {
//     const newDetails = Array.from({ length: personsCount }, () => ({
//       name: '', email: '', age: ''
//     }));
//     setPersonDetails(newDetails);
//   }, [personsCount]);

//   // OTP Functions
//   const sendOtp = async () => {
//     if (!email) {
//       setOtpError('Please enter your email address');
//       return;
//     }
//     setOtpLoading(true);
//     setOtpError('');
//     try {
//       await axios.post(`${API_BASE}/send-otp`, { email });
//       setOtpSent(true);
//       alert(t('yadnya.otpSentMessage'));
//     } catch (err) {
//       setOtpError(err.response?.data?.error || 'Failed to send OTP');
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   const verifyOtp = async () => {
//     if (!otp || otp.length !== 6) {
//       setOtpError('Please enter valid 6-digit OTP');
//       return;
//     }
//     setOtpLoading(true);
//     setOtpError('');
//     try {
//       const res = await axios.post(`${API_BASE}/verify-otp`, { email, otp });
//       localStorage.setItem('token', res.data.token);
//       setStep(2);
//     } catch (err) {
//       setOtpError(err.response?.data?.error || 'Invalid or expired OTP');
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   const updatePersonDetail = (index, field, value) => {
//     const updated = [...personDetails];
//     updated[index][field] = value;
//     setPersonDetails(updated);
//   };

//   const handleProceedToPayment = async () => {
//     if (!selectedYadnya || !selectedDate) {
//       setError("Please select Yadnya and Date");
//       return;
//     }
//     if (personDetails.some(p => !p.name || !p.email || !p.age)) {
//       setError("Please fill complete details for all persons");
//       return;
//     }

//     setLoading(true);
//     setError('');

//     try {
//       const res = await axios.post(
//         `${API_BASE}/booking/create-order`,
//         {
//           total_amount: totalAmount,
//           yadnya_id: parseInt(selectedYadnya),
//           yadnya_date: selectedDate,
//           total_person: personsCount,
//           persons: personDetails
//         },
//         { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
//       );

//       // Razorpay Options (your existing logic)
//       const options = {
//         key: res.data.key,
//         amount: totalAmount * 100,
//         currency: "INR",
//         name: "Yadnya Booking",
//         description: "Payment for Yadnya",
//         order_id: res.data.order_id,
//         handler: async function (response) {
//           // Your existing PDF download logic
//           const verifyRes = await axios.post(
//             `${API_BASE}/booking/verify-payment`,
//             {
//               user_email: email,
//               razorpay_payment_id: response.razorpay_payment_id,
//               yadnya_id: parseInt(selectedYadnya),
//               yadnya_date: selectedDate,
//               total_person: personsCount,
//               total_amount: totalAmount,
//               persons: personDetails
//             },
//             { responseType: 'blob' }
//           );

//           const url = window.URL.createObjectURL(new Blob([verifyRes.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', 'yadnya_booking.pdf');
//           document.body.appendChild(link);
//           link.click();
//         },
//         prefill: { email: email },
//         theme: { color: "#3399cc" }
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();

//     } catch (err) {
//       setError("Failed to initiate payment");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="booking-container">
//       <div className="booking-card">

//         {/* Step 1: OTP Login */}
//         {step === 1 && (
//           <div className="booking-step">
//             <div className="booking-header">
//               <h2>{t('yadnya.loginToContinue')}</h2>
//             </div>
//             <div className="booking-body">
//               <div className="form-group">
//                 <label>{t('yadnya.emailAddress')}</label>
//                 <input
//                   type="email"
//                   placeholder="Enter your email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   disabled={otpSent}
//                 />
//               </div>

//               {otpSent && (
//                 <div className="form-group">
//                   <label>{t('yadnya.enterOtp')}</label>
//                   <input
//                     type="text"
//                     maxLength={6}
//                     placeholder="6-digit OTP"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                   />
//                 </div>
//               )}

//               {otpError && <div className="error-alert">{otpError}</div>}

//               <button 
//                 className="proceed-btn" 
//                 onClick={otpSent ? verifyOtp : sendOtp}
//                 disabled={otpLoading}
//               >
//                 {otpLoading 
//                   ? 'Processing...' 
//                   : otpSent 
//                     ? t('yadnya.verifyOtp') 
//                     : t('yadnya.sendOtp')
//                 }
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Step 2: Terms & Conditions */}
//         {step === 2 && (
//           <div className="booking-step">
//             <div className="booking-header">
//               <h2>{t('yadnya.termsAndConditions')}</h2>
//             </div>
//             <div className="booking-body">
//               <div className="terms-content">
//                 <p>Please read and accept the following terms before proceeding with the booking:</p>
//                 <ul>
//                   <li>All bookings are non-refundable except in case of cancellation by the organizer.</li>
//                   <li>Valid government ID may be required at the venue.</li>
//                   <li>Participants must follow all guidelines during the Yadnya.</li>
//                 </ul>
//               </div>

//               <div className="terms">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={agreeTerms}
//                     onChange={(e) => setAgreeTerms(e.target.checked)}
//                   />
//                   {t('yadnya.agreeTerms')}
//                 </label>
//               </div>

//               <button 
//                 className="proceed-btn" 
//                 onClick={() => setStep(3)}
//                 disabled={!agreeTerms}
//               >
//                 {t('yadnya.continueToBooking')}
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Step 3: Booking Form */}
//         {step === 3 && (
//           <div className="booking-step">
//             <div className="booking-header">
//               <h2>{t('yadnya.yadnyaBooking')}</h2>
//             </div>
//             <div className="booking-body">
//               {error && <div className="error-alert">{error}</div>}

//               <div className="form-group">
//                 <label>{t('yadnya.selectYadnya')}</label>
//                 <select value={selectedYadnya} onChange={(e) => setSelectedYadnya(e.target.value)}>
//                   <option value="">-- Select Yadnya --</option>
//                   {yadnyas.map((y) => (
//                     <option key={y.id} value={y.id}>
//                       {y.title} - ₹{parseFloat(y.price_per_person).toFixed(0)}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label>{t('yadnya.selectDate')}</label>
//                 <select value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} disabled={!selectedYadnya}>
//                   <option value="">-- Select Date --</option>
//                   {dates.map((d) => (
//                     <option key={d.id} value={d.event_date}>
//                       {d.event_date}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label>{t('yadnya.numberOfPersons')}</label>
//                 <input
//                   type="number"
//                   min="1"
//                   value={personsCount}
//                   onChange={(e) => setPersonsCount(Math.max(1, parseInt(e.target.value) || 1))}
//                 />
//               </div>

//               <div className="price-box">
//                 <h5>Price Details</h5>
//                 <p>{t('yadnya.pricePerPerson')}: <strong>₹{pricePerPerson}</strong></p>
//                 <p>{t('yadnya.totalAmount')}: <strong>₹{totalAmount}</strong></p>
//               </div>

//               <h5>{t('yadnya.enterDetailsOf')} {personsCount} {t('yadnya.person')}(s)</h5>
//               {personDetails.map((person, index) => (
//                 <div key={index} className="person-card">
//                   <h6>{t('yadnya.person')} {index + 1}</h6>
//                   <div className="person-grid">
//                     <input
//                       type="text"
//                       placeholder={t('yadnya.fullName')}
//                       value={person.name}
//                       onChange={(e) => updatePersonDetail(index, 'name', e.target.value)}
//                     />
//                     <input
//                       type="email"
//                       placeholder={t('yadnya.email')}
//                       value={person.email}
//                       onChange={(e) => updatePersonDetail(index, 'email', e.target.value)}
//                     />
//                     <input
//                       type="number"
//                       placeholder={t('yadnya.age')}
//                       value={person.age}
//                       onChange={(e) => updatePersonDetail(index, 'age', e.target.value)}
//                     />
//                   </div>
//                 </div>
//               ))}

//               <button 
//                 className="proceed-btn" 
//                 onClick={handleProceedToPayment}
//                 disabled={loading}
//               >
//                 {loading ? t('yadnya.processing') : t('yadnya.proceedToPayment')}
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default YadnyaBooking;












import { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import axios from 'axios';
import './Booking.css';

const API_BASE = 'https://mhaskobaadmin.tipic.in/api';

/* ── Step progress indicator ── */
function StepStrip({ current }) {
  const steps = [1, 2, 3];
  return (
    <div className="step-strip">
      {steps.map((s, i) => (
        <>
          <div
            key={s}
            className={`step-dot ${current === s ? 'active' : current > s ? 'done' : ''}`}
          >
            {current > s ? '✓' : s}
          </div>
          {i < steps.length - 1 && (
            <div key={`line-${s}`} className={`step-line ${current > s ? 'done' : ''}`} />
          )}
        </>
      ))}
    </div>
  );
}

function YadnyaBooking() {
  const { t } = useLanguage();

  /* Razorpay script */
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  /* Steps: 1 OTP · 2 Terms · 3 Booking */
  const [step, setStep] = useState(1);

  /* OTP */
  const [email, setEmail]           = useState('');
  const [otp, setOtp]               = useState('');
  const [otpSent, setOtpSent]       = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError]     = useState('');

  /* Terms */
  const [agreeTerms, setAgreeTerms] = useState(false);

  /* Booking */
  const [yadnyas, setYadnyas]               = useState([]);
  const [selectedYadnya, setSelectedYadnya] = useState('');
  const [dates, setDates]                   = useState([]);
  const [selectedDate, setSelectedDate]     = useState('');
  const [personsCount, setPersonsCount]     = useState(1);
  const [personDetails, setPersonDetails]   = useState([{ name: '', email: '', age: '' }]);
  const [pricePerPerson, setPricePerPerson] = useState(0);
  const [error, setError]                   = useState('');
  const [loading, setLoading]               = useState(false);

  const totalAmount = pricePerPerson * personsCount;

  /* Fetch yadnyas */
  useEffect(() => {
    if (step < 3) return;
    axios.get(`${API_BASE}/yadnya`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(res => setYadnyas(res.data || []))
      .catch(console.error);
  }, [step]);

  /* Fetch dates for selected yadnya */
  useEffect(() => {
    if (!selectedYadnya || step < 3) return;
    axios.get(`${API_BASE}/yadnya/${selectedYadnya}/dates`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(res => {
        setDates(res.data || []);
        const y = yadnyas.find(y => y.id === parseInt(selectedYadnya));
        if (y) setPricePerPerson(parseFloat(y.price_per_person) || 0);
      })
      .catch(console.error);
  }, [selectedYadnya, yadnyas, step]);

  /* Sync person detail fields with count */
  useEffect(() => {
    setPersonDetails(Array.from({ length: personsCount }, () => ({ name: '', email: '', age: '' })));
  }, [personsCount]);

  /* OTP */
  const sendOtp = async () => {
    if (!email) { setOtpError('Please enter your email address'); return; }
    setOtpLoading(true); setOtpError('');
    try {
      await axios.post(`${API_BASE}/send-otp`, { email });
      setOtpSent(true);
    } catch (err) {
      setOtpError(err.response?.data?.error || 'Failed to send OTP');
    } finally { setOtpLoading(false); }
  };

  const verifyOtp = async () => {
    if (!otp || otp.length !== 6) { setOtpError('Please enter valid 6-digit OTP'); return; }
    setOtpLoading(true); setOtpError('');
    try {
      const res = await axios.post(`${API_BASE}/verify-otp`, { email, otp });
      localStorage.setItem('token', res.data.token);
      setStep(2);
    } catch (err) {
      setOtpError(err.response?.data?.error || 'Invalid or expired OTP');
    } finally { setOtpLoading(false); }
  };

  const updatePersonDetail = (index, field, value) => {
    const updated = [...personDetails];
    updated[index][field] = value;
    setPersonDetails(updated);
  };

  /* Payment */
  const handleProceedToPayment = async () => {
    if (!selectedYadnya || !selectedDate) { setError('Please select Yadnya and Date'); return; }
    if (personDetails.some(p => !p.name || !p.email || !p.age)) {
      setError('Please fill complete details for all persons'); return;
    }
    setLoading(true); setError('');
    try {
      const res = await axios.post(
        `${API_BASE}/booking/create-order`,
        { total_amount: totalAmount, yadnya_id: parseInt(selectedYadnya), yadnya_date: selectedDate, total_person: personsCount, persons: personDetails },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } },
      );

      const options = {
        key: res.data.key,
        amount: totalAmount * 100,
        currency: 'INR',
        name: 'Yadnya Booking',
        description: 'Payment for Yadnya',
        order_id: res.data.order_id,
        handler: async (response) => {
          const verifyRes = await axios.post(
            `${API_BASE}/booking/verify-payment`,
            { user_email: email, razorpay_payment_id: response.razorpay_payment_id, yadnya_id: parseInt(selectedYadnya), yadnya_date: selectedDate, total_person: personsCount, total_amount: totalAmount, persons: personDetails },
            { responseType: 'blob' },
          );
          const url = window.URL.createObjectURL(new Blob([verifyRes.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'yadnya_booking.pdf');
          document.body.appendChild(link);
          link.click();
        },
        prefill: { email },
        theme: { color: '#8B1E1E' },
      };

      new window.Razorpay(options).open();
    } catch {
      setError('Failed to initiate payment');
    } finally { setLoading(false); }
  };

  return (
    <div className="booking-container">

      {/* ── Cinematic Hero ── */}
      <div className="booking-hero">
        <div className="booking-hero-bg" />
        <div className="booking-hero-overlay" />
        <div className="booking-hero-rays">
          <div className="hero-ray hero-ray-1" />
          <div className="hero-ray hero-ray-2" />
          <div className="hero-ray hero-ray-3" />
          <div className="hero-ray hero-ray-4" />
          <div className="hero-ray hero-ray-5" />
        </div>
        <div className="booking-hero-content">
          <span className="hero-pill">🕉 Sacred Ceremony</span>
          <h1 className="hero-title">{t('yadnya.yadnyaBooking') || 'Yadnya Booking'}</h1>
          <div className="hero-divider">
            <span className="hd-line" />
            <span className="hd-diamond">◆</span>
            <span className="hd-line" />
          </div>
        </div>
        <div className="hero-bottom-line" />
      </div>

      {/* ── Body ── */}
      <div className="booking-body-wrap">
        <div className="booking-card">

          {/* Step indicator */}
          <StepStrip current={step} />

          {/* ══ STEP 1: OTP LOGIN ══ */}
          {step === 1 && (
            <div className="booking-step">
              <div className="booking-header">
                <h2>{t('yadnya.loginToContinue') || 'Login to Continue'}</h2>
                <div className="heading-bar" />
              </div>

              {otpError && <div className="error-alert">⚠ {otpError}</div>}

              <div className="form-group">
                <label>{t('yadnya.emailAddress') || 'Email Address'}</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  disabled={otpSent}
                />
              </div>

              {otpSent && (
                <div className="form-group">
                  <label>{t('yadnya.enterOtp') || 'One-Time Password'}</label>
                  <input
                    type="text"
                    maxLength={6}
                    placeholder="6-digit OTP"
                    value={otp}
                    onChange={e => setOtp(e.target.value)}
                    style={{ letterSpacing: '0.3em', fontSize: '1.1rem' }}
                  />
                </div>
              )}

              <button
                className="proceed-btn"
                onClick={otpSent ? verifyOtp : sendOtp}
                disabled={otpLoading}
              >
                {otpLoading
                  ? '⏳ Processing…'
                  : otpSent
                  ? t('yadnya.verifyOtp') || '✓ Verify OTP'
                  : t('yadnya.sendOtp') || '📧 Send OTP'}
              </button>
            </div>
          )}

          {/* ══ STEP 2: TERMS ══ */}
          {step === 2 && (
            <div className="booking-step">
              <div className="booking-header">
                <h2>{t('yadnya.termsAndConditions') || 'Terms & Conditions'}</h2>
                <div className="heading-bar" />
              </div>

              <div className="terms-content">
                <p>Please read and accept the following terms before proceeding:</p>
                <ul>
                  <li>All bookings are non-refundable except in case of cancellation by the organizer.</li>
                  <li>Valid government ID may be required at the venue.</li>
                  <li>Participants must follow all guidelines during the Yadnya.</li>
                </ul>
              </div>

              <div className="terms">
                <label>
                  <input
                    type="checkbox"
                    checked={agreeTerms}
                    onChange={e => setAgreeTerms(e.target.checked)}
                  />
                  {t('yadnya.agreeTerms') || 'I agree to the Terms & Conditions'}
                </label>
              </div>

              <button
                className="proceed-btn"
                onClick={() => setStep(3)}
                disabled={!agreeTerms}
              >
                {t('yadnya.continueToBooking') || 'Continue to Booking →'}
              </button>
            </div>
          )}

          {/* ══ STEP 3: BOOKING FORM ══ */}
          {step === 3 && (
            <div className="booking-step">
              <div className="booking-header">
                <h2>{t('yadnya.yadnyaBooking') || 'Yadnya Booking'}</h2>
                <div className="heading-bar" />
              </div>

              {error && <div className="error-alert">⚠ {error}</div>}

              <div className="form-group">
                <label>{t('yadnya.selectYadnya') || 'Select Yadnya'}</label>
                <select value={selectedYadnya} onChange={e => setSelectedYadnya(e.target.value)}>
                  <option value="">— Select Yadnya —</option>
                  {yadnyas.map(y => (
                    <option key={y.id} value={y.id}>
                      {y.title} · ₹{parseFloat(y.price_per_person).toFixed(0)} / person
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>{t('yadnya.selectDate') || 'Select Date'}</label>
                <select value={selectedDate} onChange={e => setSelectedDate(e.target.value)} disabled={!selectedYadnya}>
                  <option value="">— Select Date —</option>
                  {dates.map(d => (
                    <option key={d.id} value={d.event_date}>{d.event_date}</option>
                  ))}
                </select>
              </div>

              {/* <div className="form-group">
                <label>{t('yadnya.numberOfPersons') || 'Number of Persons'}</label>
                <input
                  type="number"
                  min="1"
                  value={personsCount}
                  onChange={e => setPersonsCount(Math.max(1, parseInt(e.target.value) || 1))}
                />
              </div> */}

              <div className="form-group">
  <label>{t('yadnya.numberOfPersons') || 'Number of Persons'}</label>
  <input
    type="number"
    min="1"
    value={personsCount}
    onFocus={() => setPersonsCount('')} // clear when user clicks
    onChange={(e) => {
      const val = e.target.value;
      if (val === '') {
        setPersonsCount('');
      } else {
        setPersonsCount(Number(val));
      }
    }}
    onBlur={() => {
      if (!personsCount || personsCount < 1) {
        setPersonsCount(1); // fallback validation
      }
    }}
  />
</div>

              {pricePerPerson > 0 && (
                <div className="price-box">
                  <h5>Price Details</h5>
                  <p>{t('yadnya.pricePerPerson') || 'Price per person'}: <strong>₹{pricePerPerson.toLocaleString()}</strong></p>
                  <p>{t('yadnya.totalAmount') || 'Total amount'}: <strong>₹{totalAmount.toLocaleString()}</strong></p>
                </div>
              )}

              <p style={{ fontSize: '0.82rem', fontWeight: 700, color: '#8B4513', textTransform: 'uppercase', letterSpacing: '0.07em', margin: '18px 0 10px' }}>
                {t('yadnya.enterDetailsOf') || 'Enter details of'} {personsCount} {t('yadnya.person') || 'person'}(s)
              </p>

              {personDetails.map((person, index) => (
                <div key={index} className="person-card">
                  <h6>{t('yadnya.person') || 'Person'} {index + 1}</h6>
                  <div className="person-grid">
                    <input
                      type="text"
                      placeholder={t('yadnya.fullName') || 'Full Name'}
                      value={person.name}
                      onChange={e => updatePersonDetail(index, 'name', e.target.value)}
                    />
                    <input
                      type="email"
                      placeholder={t('yadnya.email') || 'Email'}
                      value={person.email}
                      onChange={e => updatePersonDetail(index, 'email', e.target.value)}
                    />
                    <input
                      type="number"
                      placeholder={t('yadnya.age') || 'Age'}
                      value={person.age}
                      onChange={e => updatePersonDetail(index, 'age', e.target.value)}
                    />
                  </div>
                </div>
              ))}

              <button
                className="proceed-btn"
                onClick={handleProceedToPayment}
                disabled={loading}
              >
                {loading
                  ? t('yadnya.processing') || '⏳ Processing…'
                  : t('yadnya.proceedToPayment') || '💳 Proceed to Payment'}
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default YadnyaBooking;   